import React from 'react';
import './lost.css';

const Lost = ({ open, onRetry }) => {
  if (!open) return null;

  return (
    <div className="losepopup-overlay">
      <div className="losepopup">
        <div className="wonstars">✦ ✦ ✦</div>

        <h1>YOU LOST</h1>

        <p>Time ran out.</p>

        <div className="wonline" />

        <button onClick={onRetry}>
          TRY AGAIN
        </button>
      </div>
    </div>
  );
};

export default Lost;